/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type IngredientModalUpdateMutationVariables = {|
  id: string,
  name: string,
|};
export type IngredientModalUpdateMutationResponse = {|
  +ingredientUpdate: ?{|
    +ingredient: ?{|
      +name: string
    |}
  |}
|};
export type IngredientModalUpdateMutation = {|
  variables: IngredientModalUpdateMutationVariables,
  response: IngredientModalUpdateMutationResponse,
|};
*/


/*
mutation IngredientModalUpdateMutation(
  $id: ID!
  $name: String!
) {
  ingredientUpdate(input: {id: $id, name: $name}) {
    ingredient {
      name
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IngredientModalUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IngredientUpdatePayload",
        "kind": "LinkedField",
        "name": "ingredientUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IngredientNode",
            "kind": "LinkedField",
            "name": "ingredient",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IngredientModalUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IngredientUpdatePayload",
        "kind": "LinkedField",
        "name": "ingredientUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "IngredientNode",
            "kind": "LinkedField",
            "name": "ingredient",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "IngredientModalUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation IngredientModalUpdateMutation(\n  $id: ID!\n  $name: String!\n) {\n  ingredientUpdate(input: {id: $id, name: $name}) {\n    ingredient {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e8011a0670490e8ebbde8777b0908d15';

module.exports = node;
